import { inject, Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';

import { appsignal } from '../appsignal';

@Injectable({ providedIn: 'root' })
export class RouterBreadcrumbService implements OnDestroy {
  private readonly router = inject(Router);
  private readonly sub: Subscription;

  constructor() {
    this.sub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        appsignal.addBreadcrumb({
          category: 'navigation',
          action: 'NavigationEnd',
          metadata: { url: e.urlAfterRedirects },
        });
      });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
